import DropdownController from '../dropdown_controller';

export default class extends DropdownController {
  static targets = ['hiddenField', 'tag', 'tagText']

  hideWhenEmpty() {
    if (this.inputTarget.value == '') { this.hide() }
  }

  populateTag(text) {
    this.tagTextTarget.innerText = text
  }

  focusTag() {
    this.tagTarget.classList.add('focused')
  }

  unFocusTag() {
    this.tagTarget.classList.remove('focused')
  }

  unFocusTagOnClickAway(event) {
    const notInput = (this.hasInputTarget && this.inputTarget !== event.target)
    if (event.type == 'click' && notInput) { this.hideAll() }
  }

  clickAway(event) {
    const noTag = this.tagTarget.classList.contains('hide')
    const clickisNotOnInput = this.hasInputTarget && this.inputTarget !== event.target

    if (noTag) { 
      this.inputTarget.value = ''
      this.hiddenFieldTarget.value = ''
    }

    if (clickisNotOnInput) { this.hide(event) }
  }

  hideTagOnDelete(event) {
    if (event.key == 'Backspace') { this.hideTag(event) }
  }

  showTag() {
    this.tagTarget.classList.remove('hide')
    this.inputTarget.setAttribute('disabled', true)
    document.getElementById('dollar').focus()
  }

  hideTag(event) {
    event.preventDefault()
    this.tagTarget.classList.add('hide')
    this.hiddenFieldTarget.value = ''
    this.inputTarget.value = ''
    this.inputTarget.removeAttribute('disabled')
    this.inputTarget.focus()
  }

  selectAndFillHiddenField(event) {
    event.preventDefault();
    const selectedValue = event.target.dataset.value
    const selectedText = event.target.innerHTML

    this.hiddenFieldTarget.value = selectedValue
    this.inputTarget.value = selectedText
    this.hide()
    this.populateTag(selectedText)
    this.showTag()
    this.inputTarget.focus()
  }
}